<template>
  <footer class="footer full-section fp-auto-height">
    <div class="footer__inner">
      <nav class="footer__navigation" aria-label="Навигация в подвале сайта">
        <section
          v-for="group in navigationGroups"
          :key="group.title"
          class="footer__group"
        >
          <UiTypography tag="h2" variant="header03">
            {{ group.title }}
          </UiTypography>

          <div class="footer__links">
            <UiTextButton
              v-for="item in group.items"
              :key="item.title"
              variant="text-static"
              :to="item.external ? '' : item.link"
              :href="item.external ? item.link : ''"
              v-bind="item.external ? externalLinkAttributes : {}"
              @click="handleItemClick(item)"
            >
              {{ item.title }}
            </UiTextButton>
          </div>
        </section>

        <section class="footer__group footer__group--social-desktop">
          <UiTypography tag="h2" variant="header03">Соц.сети</UiTypography>

          <div class="footer__links">
            <UiTextButton
              v-for="item in social"
              :key="item.title"
              variant="text-static"
              :href="item.link"
              v-bind="externalLinkAttributes"
              @click="handleItemClick(item)"
            >
              {{ item.title }}
            </UiTextButton>
          </div>
        </section>
      </nav>

      <div class="footer__cta">
        <UiTypography
          tag="p"
          variant="small"
          class="footer__description"
        >
          {{ companyText }}
        </UiTypography>

        <div class="footer__buttons">
          <UiOutlineButton
            v-for="item in buttons"
            :key="item.title"
            :to="item.link"
            theme="dark"
            full-width
          >
            {{ item.title }}
          </UiOutlineButton>
        </div>
      </div>

      <UiTypography tag="p" variant="small" class="footer__copyright">
        © Lithium 2015 – {{ new Date().getFullYear() }} / Made in Russia, Kirov – Vyatka
      </UiTypography>

      <div class="footer__secondary-links">
        <UiTextButton
          v-for="item in secondaryLinks"
          :key="item.title"
          class="footer__secondary-link"
          variant="text-static"
          :to="item.link"
        >
          <span class="footer__secondary-label footer__secondary-label--desktop">
            {{ item.desktopTitle }}
          </span>
          <span class="footer__secondary-label footer__secondary-label--mobile">
            {{ item.mobileTitle }}
          </span>
        </UiTextButton>
      </div>

      <div class="footer__social-mobile">
        <UiTextButton
          v-for="item in social"
          :key="item.title"
          variant="text-static"
          :href="item.link"
          v-bind="externalLinkAttributes"
          @click="handleItemClick(item)"
        >
          {{ item.title }}
        </UiTextButton>
      </div>
    </div>
  </footer>
</template>

<script>
import {
  UiOutlineButton,
  UiTextButton,
  UiTypography
} from '@/components/common/ui'

export default {
  name: 'Footer',

  components: {
    UiOutlineButton,
    UiTextButton,
    UiTypography
  },

  data () {
    return {
      externalLinkAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      navigationGroups: [
        {
          title: 'Коллекции',
          items: [
            {
              title: 'Кухни',
              link: '/products/kitchens',
              clickParams: [null, 'katalog', null]
            },
            { title: 'Гардеробные системы', link: '/products/wardrobes' },
            { title: 'Диваны', link: '/products/sofas' },
            { title: 'Керамика', link: '/ceramics' },
            {
              title: 'Реализованные проекты',
              link: '/projects',
              clickParams: [null, 'Click_projects', null]
            },
            { title: 'Дизайн', link: '/design' }
          ]
        },
        {
          title: 'Компания',
          items: [
            { title: 'О фабрике', link: '/brand' },
            {
              title: 'Шоурумы',
              link: '/contacts',
              clickParams: [null, 'click_contacts', null]
            },
            { title: 'Сервис', link: '/service' },
            { title: 'Соглашение об ПД', link: '/personal' },
            { title: 'Политика ПД', link: '/policy' }
          ]
        }
      ],
      social: [
        {
          title: 'Instagram',
          link: 'https://instagram.com/lithium_kitchen',
          external: true
        },
        {
          title: 'Telegram',
          link: 'https://telegram.me/lithiumhome',
          external: true,
          clickParams: ['eWthuwfc', 'clicktg', 'click_tg']
        },
        {
          title: 'YouTube',
          link: 'https://www.youtube.com/@lithiumhome',
          external: true
        },
        {
          title: 'Pinterest',
          link: 'https://pinterest.com/Lithium_kitchen/',
          external: true
        },
        {
          title: 'ВКонтакте',
          link: 'https://vk.com/lithium_kitchen',
          external: true
        }
      ],
      companyText: 'LITHIUM — это детали, которые нужно видеть. Посетите шоурум или отправьте заявку — и мы подскажем, с чего начать ваш проект.',
      buttons: [
        { title: 'Наши шоурумы', link: '/contacts' },
        { title: 'Оставить заявку', link: '/application' }
      ],
      secondaryLinks: [
        {
          title: 'Партнерская программа',
          desktopTitle: 'Сотрудничество с дизайнерами и архитекторами',
          mobileTitle: 'Партнерская программа',
          link: '/friends'
        },
        {
          title: 'Контрактное направление',
          desktopTitle: 'Контрактное направление',
          mobileTitle: 'Контрактное направление',
          link: '/contract'
        }
      ]
    }
  },

  methods: {
    handleItemClick (item) {
      if (!item.clickParams) return
      this.handleDSPClick(...item.clickParams)
    },

    handleDSPClick (siteArea, goalName, trmGoal) {
      if (siteArea) {
        try {
          const userId = localStorage.getItem('user_id') || ''
          DSPCounter('send', {
            sid: '230574',
            site_area: siteArea,
            user_id: userId,
            lead_id: '',
            order_sum: ''
          })
        } catch (error) {
          console.warn('DSPCounter error:', error)
        }
      }

      if (goalName && typeof ym === 'function') {
        ym(88776155, 'reachGoal', goalName)
      }

      if (trmGoal && typeof _tmr !== 'undefined') {
        _tmr.push({ type: 'reachGoal', id: 3563947, goal: trmGoal })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  box-sizing: border-box;
  min-height: auto;
  padding: vw(60) vw(122);
  border-top: vw(1) solid #cdcdcd;
  background: #fff;

  &__inner {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto auto;
    gap: 0 vw(20);
    min-height: vw(246);
    align-content: space-between;
  }

  &__navigation {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: vw(20);
  }

  &__group {
    display: flex;
    flex-direction: column;
    gap: vw(20);
  }

  &__links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: vw(4);
  }

  &__cta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: vw(20);
  }

  &__description {
    max-width: vw(379);
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    gap: vw(12);
  }

  &__copyright {
    align-self: end;
  }

  &__secondary-links {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    gap: vw(20);
    align-self: end;
  }

  &__secondary-link {
    font-size: vw(12);
    line-height: vw(12);
    text-decoration: underline;
    text-underline-offset: vw(2);
    text-transform: uppercase;
  }

  &__secondary-label--mobile {
    display: none;
  }

  &__social-mobile {
    display: none;
  }
}

@include max-width(mobile) {
  .footer {
    padding: vwm(32) vwm(18);
    border-top-width: vwm(1);

    &__inner {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    &__navigation {
      order: 1;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: vwm(18);
    }

    &__group {
      gap: vwm(20);
    }

    &__group--social-desktop {
      display: none;
    }

    &__links {
      gap: vwm(4);
    }

    &__cta {
      order: 2;
      display: block;
      margin-top: vwm(64);
    }

    &__description {
      display: none;
    }

    &__buttons {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: vwm(18);
    }

    &__secondary-links {
      order: 3;
      display: flex;
      flex-direction: column;
      align-self: flex-start;
      align-items: flex-start;
      gap: vwm(20);
      margin-top: vwm(64);
    }

    &__secondary-link {
      font-size: vwm(12);
      line-height: vwm(12);
      text-underline-offset: vwm(2);
    }

    &__secondary-label--desktop {
      display: none;
    }

    &__secondary-label--mobile {
      display: inline;
    }

    &__social-mobile {
      order: 4;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: vwm(96);
    }

    &__copyright {
      order: 5;
      align-self: flex-start;
      margin-top: vwm(32);
      text-align: left;
    }
  }
}
</style>
